import React from 'react';
import { graphql } from 'gatsby';
import WebinarsPage from 'components/pages/WebinarsPage';

const seo = {
  title: 'Découvrez tous les replays et les prochains webinaires Q°emotion',
  keywords: [],
  description:
    'Vous souhaitez en savoir plus sur l’analyse sémantique émotionnelle de vos verbatims et avis clients ? Découvrez les webinaires préparés par nos experts ! Inscrivez-vous aux prochains ou visionnez nos replay.',
};

export default props => <WebinarsPage {...props} seo={seo} />;

export const pageQuery = graphql`
  query {
    dataIntroBlockTitle: markdownRemark(
      frontmatter: {
        pageType: { eq: "webinars" }
        blockType: { eq: "introBlock" }
        component: { eq: "title" }
        lang: { eq: "fr" }
      }
    ) {
      html
    }
    allImages: allFile(filter: { relativeDirectory: { eq: "bubbleImages" } }) {
      nodes {
        base
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            presentationWidth
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
    allWebinars: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "webinars" }
          blockType: { eq: "webinarBlock" }
          lang: { eq: "fr" }
        }
      }
      sort: { fields: [frontmatter___index], order: DESC }
    ) {
      nodes {
        frontmatter {
          title
          id
          duration
        }
        html
      }
    }
    dataBlockLinkBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "clientCase" }
          blockType: { eq: "linkBlock" }
          lang: { eq: "fr" }
        }
      }
      sort: { fields: [frontmatter___idBlock] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          subTitle
          color
          link
          buttonText
        }
      }
    }
  }
`;
